import { combineReducers } from '@reduxjs/toolkit'
import session from './sessionSlice'
import user from './userSlice'
import admin from './userSlice'

const reducer = combineReducers({
    session,
    user,
    admin,
})

export default reducer
